import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {  useNavigate} from 'react-router-dom'

// import Cookies from 'universal-cookie';

// const cookies = new Cookies();
// const cookie = cookies.get('token');

function MyProfileSidebar(props) {
    const navigate = useNavigate();
    const [image, setImage] = useState(false)
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastname] = useState("");
    const [loader, setloader] = useState("")
    const [disable, setdisable] = useState(false);

    
    function handleBack() {
         
        document.querySelector(".myProfile").classList.remove("translateProfile");
    }
   
    
    function postDetails(e){
        setloader("loader")
        setdisable(true);
        // const d = URL.createObjectURL(e.target.files[0]);
        // console.log(d);
        const data = new FormData();
        data.append("file",e.target.files[0]);
        data.append("upload_preset","ChatApp");
        data.append("cloud_name","dgz1wimeg")
        axios.post("https://api.cloudinary.com/v1_1/dgz1wimeg/image/upload",data).then(res=>{
           
            var imgtag = document.getElementById("myimage");
            imgtag.src = res.data.url;
            setloader("")
            setdisable(false);
            props.getMyImg(res.data.url);
            axios.post("https://newchatapp-mn65.onrender.com/myimg",{image:res.data.url}, {
                headers: {
                    Authorization: 'Bearer ' + props.token
                }
            })
            
        });
        setImage(true);
    }

   

    const  myProfileDatabaseName = async (data)=> {
            
        if(data.name){
            await axios.post("https://newchatapp-mn65.onrender.com/myprofiledatabase", { firstname:data.name },{
            headers: {
                Authorization: 'Bearer ' + props.token
            }
        })
        }else{
            await axios.post("https://newchatapp-mn65.onrender.com/myprofiledatabase", { lastname:data.surname },{
            headers: {
                Authorization: 'Bearer ' + props.token
            }
        })
        }
    }

    // ?props.image:"images/defaultProfile.png"
    return (

        <div className="myProfile">
            <div style={{userSelect:"none"}} className="myProtileTop">
                <i onClick={handleBack} style={{ fontSize: "1.2rem", cursor: "pointer" }} className="fa-solid fa-arrow-left"></i>
                <p>Profile</p>
            </div>
            <div className="myProfileBody">
                <div style={{userSelect:"none"}} className={!image && props.image==="images/defaultProfile.png" ? "myProfileBodydiv iamgeSelector mypicOpacitydiv" : "iamgeSelector myProfileBodydiv"}>
                    <img  id="myimage" className={!image && props.image==="images/defaultProfile.png" ? 'myProfileBodydivPic mypicOpacity' : 'myProfileBodydivPic'} src={props.image} alt="" />
                    <input title={!image && !props.image ?"select Photo":"Photo"} disabled={disable} onChange={postDetails} type="file" name="" />
                    <div className={loader}></div>
                </div>
                <div className="myProfileBodyDetail">
                    <div>
                        <label htmlFor="#firstname">First name</label>
                        <p title='first name' suppressContentEditableWarning={true} onInput={(e) => {if(e.target.innerHTML.length>13){e.target.innerHTML=firstname; alert("Name length must be less than 14")}else{ setFirstName(e.target.innerHTML);} }} onBlur={(e)=>{myProfileDatabaseName({name:e.target.innerHTML})}} contentEditable={true} id="firstname">{props.firstname}</p>
                    </div>
                    <div>
                        <label htmlFor="#lastname">Last name</label>
                        <p title="last name" suppressContentEditableWarning={true} onInput={(e) => {if(e.target.innerHTML.length>13){e.target.innerHTML=lastname; alert("length must be less than 14")}else{ setLastname(e.target.innerHTML);} }} onBlur={(e)=>{myProfileDatabaseName({surname:e.target.innerHTML})}} contentEditable={true} id="lastname">{props.lastname}</p>
                    </div>
                </div>
                <p style={{ padding: "0 2.2rem", color: "#8696a0", fontWeight: "500",userSelect:"none" }}>This is not your username or pin. This name will be visible to your ChatApp contacts.</p>

            </div>
        </div>

    )
}

export default MyProfileSidebar